import createAPIRequest from "../helpers/createAPIRequest";
import handleError from "../helpers/handleError";
import store from "../store/index";

//-------------
// delete race
//-------------
export default async function useDeleteRace(slug) {
  // console.log("----------------")
  // console.log("IN useDeleteRace...")
  //--------------
  // access store
  //--------------
  const this_store = store;
  //--------------------
  // set api call parms
  //--------------------
  let request_parms = {
    endpoint: "api/v1/races/",
    slug: slug,
    deleteInd: true,
  };
  //--------------------
  // create api request
  //--------------------
  let request = createAPIRequest(request_parms);
  //--------------------------------
  // make store API call (deletion)
  //--------------------------------
  let api_call = this_store.dispatch("races/deleteRace", request);
  //---------------
  // await results
  //---------------
  await api_call
    //----------
    // where ok
    //----------
    .then(() => {
    })
    //-------------
    // where error
    //-------------
    .catch((err) => {
      handleError(err,10);
    });
}
